export default function ({ redirect, app }) {
  // If the user is not authenticated
  if (app.$auth.isAuthenticated) {
    return redirect(app.localePath('index'))
  }
  return Promise.resolve()
}
